// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Sm-z","tupacHeader":"Tm-z","tupacHeader2":"Um-z","tupacMenu":"Vm-z","tupacMenu2":"Wm-z","tupacMain":"Xm-z","tupacMain2":"Ym-z"};